'use client'
import { useGetAdsQuery } from '@/app/globalRedux/api/adsSlice'
import { useGetProductSearchQuery } from '@/app/globalRedux/api/searchSlice'
import { RootState } from '@/app/globalRedux/store'
import { AdBannerScheduleType } from '@/app/types/adType'
import { ProductSearchResponse } from '@/app/types/productSearchType'
import { convertNaNToOne } from '@/lib/formatUtils'
import { useParams, usePathname } from 'next/navigation'
import { useSelector } from 'react-redux'
import ProductPage from '../ProductPage'
const SearchResultProductPage = () => {
  const params = useParams<{ lng: string; productPageNO: string[] }>()
  const productsFilter = useSelector((state: RootState) => state.productFilter)
  const commonFilter = useSelector((state: RootState) => state.commonFilter)
  const pathName = usePathname()
  const isOfferTab = pathName?.split('/')?.includes('product-tab')
  const { data: productAds } = useGetAdsQuery<{
    data: AdBannerScheduleType[]
    isLoading: boolean
    isError: boolean
    isFetching: boolean
  }>({
    page: `Search Results ${isOfferTab ? 'Offers' : 'Products'}`,
    lang: params.lng,
  })
  const {
    data: productData,
    isFetching: isProductDataFetching,
    isError: isProductError,
  } = useGetProductSearchQuery<{
    data: ProductSearchResponse
    isFetching: boolean
    isError: boolean
    isLoading: boolean
    isSuccess: boolean
  }>(
    {
      productsFilter: productsFilter,
      commonFilter: commonFilter,
      pageNo: convertNaNToOne(Number(params?.productPageNO?.[0]) || 1),
    },
    {
      skip: productsFilter?.isRouteUpdating,
    }
  )

  return (
    <ProductPage
      adList={productAds ?? []}
      productData={productData}
      isLoading={isProductDataFetching || isProductError}
    />
  )
}

export default SearchResultProductPage
